import { Icon, Typography } from '@eventr/common-storybook'
import { Stack } from '@mui/material'
import i18n from '../../i18n/i18next'

export const OrgIsBeeingMade = () => {
    return (
        <Stack
            height={'100%'}
            direction={'column'}
            justifyContent={'center'}
            width={'100%'}
            alignItems={'center'}
        >
            <Typography margin={'16px'} variant="bodyBold" textAlign={'center'}>
                <div id="orgIsBeingCreatedText">
                    {i18n.t('account.team-creating')}
                </div>
            </Typography>
            <Icon name="Loading" />
        </Stack>
    )
}
